import { AttachmentImage } from "@/components/ui/attachment-media";

/**
 * A PDF's cover, the same on its wall card and in its preview: the stored
 * first-page thumbnail (pdf.js pixels), else a calm paper sheet with the
 * title. It fills its box; paper dims slightly on ink cards.
 */
export function PdfCover({
  thumbnailUrl,
  title,
}: {
  /** The stored page-1 thumbnail, else "". */
  thumbnailUrl: string;
  title: string;
}) {
  if (thumbnailUrl) {
    return (
      <AttachmentImage
        src={thumbnailUrl}
        alt=""
        className="block h-full w-full bg-[var(--card-paper)] object-cover object-top [filter:var(--card-paper-filter)]"
        data-testid="file-card-pdf-page"
        draggable={false}
      />
    );
  }
  return (
    <div
      className="h-full bg-[var(--card-paper)] px-[9%] pt-[28%] text-[color:var(--page-ink-on-light)]"
      data-testid="file-card-paper"
    >
      <p className="line-clamp-5 font-display text-[1.6em] font-medium leading-[1.12] tracking-[-0.025em]">
        {title}
      </p>
    </div>
  );
}
